import Stories from './Stories.vue';

export default Stories;
